module.exports = __webpack_public_path__ + "img/76ne.b7f55a7a.svg";